<!-- <ng-container *ngIf="lookupdata.length > 0"> -->
<section class="mx-3">
  <ng-container>
    <div class="d-flex justify-content-between align-items-center">
      <div class="page_header">
        <h4 translate class="m-0 page_header_title">Academic Calendar List</h4>
      </div>
      <!-- <div *ngIf="actiondata.create">
              <button
                mat-raised-button
                color="primary"
                (click)="openAddAcademicsDialog()"
                class="px-5 add_button"
              >Add</button>
            </div> -->
    </div>
    <div class="position-relative">
      @if (isLoadingResults || isRateLimitReached) {
      <div class="loading-shade">
        @if (isLoadingResults) {
        <mat-spinner class="mat_spinner"></mat-spinner>
        } @if (isRateLimitReached) {
        <div class="rate-limit-reached">
          API rate limit has been reached. It will be reset in one
          minute.
        </div>
        }
      </div>
      }
      <ng-container *ngIf="actiondata?.list_view">
        <div class="mt-2 table-container">
          <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
            <ng-container matColumnDef="start_year">
              <th translate mat-header-cell *matHeaderCellDef>Start Date</th>
              <td mat-cell *matCellDef="let element">{{ element.start_date }}</td>
            </ng-container>
            <ng-container matColumnDef="end_year">
              <th translate mat-header-cell *matHeaderCellDef>End Date</th>
              <td mat-cell *matCellDef="let element">
                {{ element.end_date}}
              </td>
            </ng-container>
            <ng-container matColumnDef="course_name">
              <th translate mat-header-cell *matHeaderCellDef>Course Name</th>
              <td mat-cell *matCellDef="let element">
                <div class="status-container">
                  {{ element.course_name }}
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="academic_regulation_code">
              <th translate mat-header-cell *matHeaderCellDef>Academic Regulation</th>
              <td mat-cell *matCellDef="let element">
                <div class="status-container">
                  {{ element.academic_regulation_code }} ({{element.regulation_start_year}} -
                  {{element.regulation_end_year}})
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="actions">
              <th translate mat-header-cell *matHeaderCellDef>Actions</th>
              <td mat-cell *matCellDef="let row">
                <div class="d-flex align-items-center">
                  <p translate class="m-0 cursor_pointer" (click)="showsemesterdetails(row)">
                    View
                  </p>
                    <div class="action_button cursor_pointer" [matMenuTriggerFor]="createmenu">
                      <i class="fa-solid fa-ellipsis-vertical" aria-hidden="false"></i>
                    </div>
                  <mat-menu #createmenu="matMenu">
                    <small translate [disabled]="this.selection.selected.length == 0" mat-menu-item
                      (click)="openAddAcademicsDialog(row)">Edit</small>
                  </mat-menu>
                </div>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="selection.toggle(row)"></tr>
            <tr class="mat-row" *matNoDataRow>
              <td translate class="mat-cell" colspan="4">No data</td>
            </tr>
          </table>
        </div>
        <div class="mt-2" *ngIf="total_count > 5">
          <app-pagination [datafromparent]="total_count" (onDatePicked)="pagination($event)"></app-pagination>
        </div>
      </ng-container>
    </div>
  </ng-container>
</section>